export const COMPETITION_CONSTANTS = Object.freeze({
    LIVE: 'live',
    ENDED: 'ended',
    NEW: 'new',
});
